import { Collapse, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ArrowDownIcon } from '../../icons/arrow-down-icon';
import { ArrowUpIcon } from '../../icons/arrow-up-icon';
import CustomButton from '../buttons/custom-button/custom-button';
import styles from './alert-archive.module.css';

interface Props {
  onAction: () => void;
}

const AlertArchive = ({ onAction }: Props): JSX.Element => {
  const { t } = useTranslation('common');

  return (
    <div className={styles.alertArchiveContainer}>
      <Collapse
        expandIcon={panelProps => (panelProps.isActive ? <ArrowUpIcon /> : <ArrowDownIcon />)}
        expandIconPlacement="end"
        defaultActiveKey="alert-archive"
      >
        <Collapse.Panel
          key="alert-archive"
          header={
            <Typography.Title level={3} type="danger" className={styles.archiveTitle}>
              {t('archiveRequest.title')}
            </Typography.Title>
          }
        >
          <Typography.Paragraph className={styles.archiveAdditionalText}>
            {t('archiveRequest.additionalText')}
          </Typography.Paragraph>
          <CustomButton fontWeight={400} fontSize={12} size="small" onClick={onAction}>
            {t('archiveRequest.action.showUnarchived')}
          </CustomButton>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
};

export default AlertArchive;
